import Vue from 'vue';
import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
import '@egjs/vue-flicking/dist/flicking-inline.css';

Vue.use(Flicking);
